var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BookingSelectList",
      "extra-items": [{
        text: _vm.bookingPresetName,
        to: 'BookingList',
        params: _vm.$route.params.id
      }, '基本設定']
    }
  })], 1)]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row bg-white"
  }, [_c('div', {
    staticClass: "col-md-2 mail-sidebar pt-3"
  }, [_c('div', {
    staticClass: "menu-bar"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [_c('li', {
    class: {
      active: _vm.step == '',
      'has-checkbox': true,
      'has-checkbox--checked': _vm.bookingPresetId
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('');
      }
    }
  }, [_c('a', [_vm._v("基本設定")])])])])]), _c('div', {
    staticClass: "col-md-10 main-view"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_vm.step == '' ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.bookingPresetName) + " ")]), _c('div', {
    staticClass: "col-12 col-xl-6 mb-3"
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.branchOptions
    },
    on: {
      "input": _vm.formatAndFetchPreset
    },
    model: {
      value: _vm.branch,
      callback: function callback($$v) {
        _vm.branch = $$v;
      },
      expression: "branch"
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-xl-12"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "預約說明"
    }
  }, [_c('TrixEditor', {
    model: {
      value: _vm.bookingPresetBranch.config.basic.tips,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPresetBranch.config.basic, "tips", $$v);
      },
      expression: "bookingPresetBranch.config.basic.tips"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e()])], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }